export default __webpack_public_path__ + "static/microapps-5555b32042fe606698a5275cf052a258.png";